import { useMemo } from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import { Box, Typography } from '@mui/material';

const ADD_COLOR = '#2e7d32';
const REMOVE_COLOR = '#d32f2f';

export default function SubmissionDiffMap({ items = [], height = 220 }) {
  const geoItems = useMemo(
    () => items.filter((i) => i.latitude != null && i.longitude != null),
    [items],
  );

  const bounds = useMemo(() => {
    if (geoItems.length === 0) return null;
    let minLat = Infinity;
    let maxLat = -Infinity;
    let minLng = Infinity;
    let maxLng = -Infinity;
    geoItems.forEach((i) => {
      if (i.latitude < minLat) minLat = i.latitude;
      if (i.latitude > maxLat) maxLat = i.latitude;
      if (i.longitude < minLng) minLng = i.longitude;
      if (i.longitude > maxLng) maxLng = i.longitude;
    });
    const pad = 0.02;
    return [
      [minLat - pad, minLng - pad],
      [maxLat + pad, maxLng + pad],
    ];
  }, [geoItems]);

  if (!geoItems.length || !bounds) {
    return (
      <Box
        sx={{
          height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
        }}
      >
        <Typography variant="caption" color="text.secondary">
          No geometry available for this submission.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height, borderRadius: 1, overflow: 'hidden', border: 1, borderColor: 'divider' }}>
      <MapContainer
        bounds={bounds}
        boundsOptions={{ padding: [10, 10] }}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
        attributionControl={false}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {geoItems.map((item) => {
          const color = item.action === 'add' ? ADD_COLOR : REMOVE_COLOR;
          return (
            <CircleMarker
              key={item.id}
              center={[item.latitude, item.longitude]}
              radius={5}
              pathOptions={{
                color,
                fillColor: color,
                fillOpacity: 0.7,
                weight: 1.5,
              }}
            >
              <Tooltip direction="top" offset={[0, -4]}>
                <span>
                  {item.action === 'add' ? '+ ' : '− '}
                  {item.zip || item.zip_raw}
                  {item.city ? ` · ${item.city}` : ''}
                </span>
              </Tooltip>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </Box>
  );
}
